import * as React from 'react';
import { useAppSelector } from '../../../../contexts/hooks';
import { NoDataPanel } from '../../..';
import { formatMessage } from 'devextreme/localization';

const Index = () => {
  const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  if (!idOrd || idOrd === -1) {
    return <NoDataPanel title={formatMessage("OrdNoDataTitle")} description={formatMessage("OrdNoDataDescription")} />
  }
  return <h2>seroteca</h2>;
};

export default Index;
